<div class="h-screen flex flex-column flex-grow-1 bg-cover" style="background: url('assets/layout/images/pages/login-bg.jpg')">
    <div class="align-self-center mt-auto mb-auto">
        <div class="text-center z-5 flex flex-column border-1 border-round-md surface-border surface-card px-3">
            <br>
            <h4>eArhiv</h4>

            <div class="text-color-secondary mb-6 px-6">Unesite novu zaporku</div>
            <form [formGroup]="changePasswordForm" (ngSubmit)="onFormSubmit(changePasswordForm.value)">
                <div class="w-full flex flex-column gap-3 px-3 pb-6">
                    <span class="p-input-icon-left">
                        <i class="pi pi-key"></i>
                        <input type="password" class="w-full" pInputText placeholder="Nova zaporka"
                        [formControl]="changePasswordFormControl('newPassword')"/>
                    </span>
                    <div *ngIf="changePasswordForm.get('newPassword')?.hasError('required') && changePasswordForm.get('newPassword')?.touched"
                        class="alert-message">
                        Nova zaporka je obavezna.
                    </div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-key"></i>
                        <input type="password" class="w-full" pInputText placeholder="Ponovite zaporku"
                        [formControl]="changePasswordFormControl('repeatPassword')"/>
                    </span>
                    <div *ngIf="changePasswordForm.get('repeatPassword')?.hasError('required') && changePasswordForm.get('repeatPassword')?.touched"
                        class="alert-message">
                        Polje ponovite zaporku je obavezno.
                    </div>
                    <div *ngIf="changePasswordForm.hasError('nomatch')  && (changePasswordForm.get('newPassword')?.dirty)
                      && (changePasswordForm.get('repeatPassword')?.dirty)"
                        class="alert-message">
                        Zaporke se ne podudaraju.
                    </div>
                    <button pButton pRipple type="submit" class="w-full my-3 px-3" label="Postavite novu zaporku"></button>
                </div>
            </form>
        </div>
    </div>
</div>